//custom functions

// Add extra leading 0 to timer values
window.doubleDigits = function (value)
{
    value = parseInt(value);
    return (value)<=9 && (value>=0) ? '0'+value : value;
}

let cssAnimFade = {
    "transition-property": "-moz-filter, -ms-filter, -o-filter, -webkit-filter, filter",
    "transition-duration": "1s",
    "filter":"grayscale(100%) blur(2px)",
    "-webkit-filter":"grayscale(100%) blur(2px)",
    "-moz-filter":"grayscale(100%) blur(2px)",
    "-o-filter":"grayscale(100%) blur(2px)",
};
// fade form window
window.fadeFormOnSubmit = function (id, hide = '')
{
    $(id).on("submit", function()
    {
        if (hide != '')
        {
            $(id + " " + hide).fadeOut();
        }
        $(id).css(cssAnimFade);
    })
}

// fade element window
window.fadeElement = function (id, hide = '')
{

    if (hide != '')
    {
        $(id + " " + hide).fadeOut();
    }
    $(id).css(cssAnimFade);

}

window.isNumber = function isNumber(val) {
    return (val != undefined && val != null && val.toString().length > 0 && val.toString().match(/[^0-9\.\-]/g) == null);
}

